import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import { useNavigate } from 'react-router-dom';
import useFetchUsers from '../../hooks/fetchUsers';
import { Pagination, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { EditTwoTone } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import NoRecordFound from '../../components/common/NoRecordFound';

function Users() {
  const { t } = useTranslation(['common']);
  let { Search } = Input;
  let navigate = useNavigate();
  let users;
  let searchedUser;
  const token=getTokenfromUserObj();
  const [editbtn, setEditBtn] = useState('none');
  const [search, setSearch] = useState('');
  const [current, setCurrent] = useState(1);
  const [fetchUsers, setFetchUsers] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [renderList, setRenderList] = useState();
  const [tableShow, setTableShow] = useState(true);
  const [err, setErr] = useState('');
  const user = JSON.parse(localStorage.getItem('user'));
  const userResp = useFetchUsers();
  console.log(userResp);
  const userCount = userResp.response ? userResp.response.data.length : 0;
  console.log(userCount);
  useEffect(() => {
    const userList = async () => {
      if (user.userType === 'A') setEditBtn('block');
      const limit = 1000;
      const offset = 0;
      let getUserAPI;
      if(user.userType==="A")getUserAPI =`${app.URL}/user/getuserspage`;
      else if(user.userType==="O")getUserAPI =`${app.URL}/user/getorguserspage/${user.organizationId}`
      const userResp = await axios.post(getUserAPI,{ limit, offset },{headers:{auth:token}});
      console.log('🚀 ~ file: Users.js:31 ~ userList ~ userResp', userResp.data);
      userResp.data ? setFetchUsers(userResp.data.data) : ' ';
      userResp.data ? setPagesCount(userResp.data.data.length) : ' ';
      userResp.data ? setRenderList(userResp.data.data.slice(0, 50)) : ' ';
    };
    userList();
  }, []);
  console.log(fetchUsers)
  console.log(renderList)
  const handleSearch = async () => {
    console.log('calling');
    try {
      const result = search ? await axios.post(`${app.URL}/user/search/${search}`) : [];
      console.log(result);
      searchedUser = result.data.data;
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }

    console.log(searchedUser);
    if (searchedUser) {
      setSearchShow(true);
      setRenderList(searchedUser);
    }
    console.log(searchedUser);
  };
  const onSearch = async (value) => {
    console.log(value);
    try {
      const result = await axios.post(`${app.URL}/user/search/${value}`,user,{headers:{auth:token}});
      console.log(result);
      searchedUser = result.data.data;
      setRenderList(searchedUser);
      setPagesCount(searchedUser.length);
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }
  };
  const onChange = async (page, pageSize) => {
    console.log(page);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    setRenderList(fetchUsers.slice(reqObj.offset, reqObj.offset + limit));
    // if(users){
    //   console.log("users")
    //   setRenderList(users)
    // }
    console.log(renderList);
  };

  const handleSearchChange = (e) => {
    console.log(e.target.value);
    if (!e.target.value) {
      setRenderList(fetchUsers.slice(0, 50));
      //  console.log(organizations.length)
      setPagesCount(fetchUsers.length);
      setTableShow(true);
    }
    setSearch(e.target.value);
  };

  const editUser = (e) => {
    console.log(e);
    localStorage.setItem('getUserId', JSON.stringify(e.userId));
    if(user.userType==="A")navigate('/user/edit', { replace: true });
    else if(user.userType==="O")navigate('/orguser/edit', { replace: true });
    // navigate('/user/edit', { replace: true });
  };
  const addUser = () => {
    if(user.userType==="A")navigate('/user/add', { replace: true });
    else if(user.userType==="O")navigate('/orguser/add', { replace: true });
    // navigate('/user/add', { replace: true });
  };
  console.log(renderList);

  return (
    <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
      <div className='row mt-4'>
        <div className='col-lg-10 col-md-10 col-sm-10 fs-3 fw-bold'>{t('User Management')}</div>
        {/* <div className="col-lg-2 col-md-2 col-sm-2">
        <button class="btn btn-primary button" onClick={addUser}>Add</button>  
        </div>   */}
      </div>
      <div className='row text-center'>
        <div className='col-lg-8 mt-4 offset-lg-1'>
          <Search
            placeholder='Search by ID/ Name/ Email'
            className='search'
            onChange={handleSearchChange}
            onSearch={onSearch}
            style={{
              width: 300,
            }}
          />
        </div>
        <div className='col-lg-2 col-md-2 col-sm-2 mt-4 ml-2'>
          <button class='btn btn-primary button' onClick={addUser}>
            Add
          </button>
        </div>
      </div>

      <div className='col-lg-11 col-md-12 col-sm-12 '>
        <div class=' styled-table '>
          <table class='table text-black'>
            <thead class='thead-light'>
              <tr>
                {/* <th>{t("ID")}</th> */}
            {user.userType==="A"? <th>{t('Organization')}</th>:" "}   
                <th>{t('Name')}</th>
                <th>{t('Email')}</th>
                <th>{t('Mobile')}</th>
                <th>{t('User Type')}</th>
                <th>{t('Status')}</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {renderList
                ? renderList.map((output) => (
                    <tr
                      className='row-hover'
                      onClick={() => {
                        editUser(output);
                      }}
                    >
                      {/* <td >{output.userId}</td> */}
                      {/* onClick={()=>{editUser(output)}} style={{color:"blue",textDecoration:"underline", width:"160px"}} */}
                      {user.userType==="A"?  <td style={{ width: '200px' }}>{output.organizationName ? output.organizationName : "Admin (Donation4all)"}</td>:" "}
                      <td style={{ width: '200px' }}>{output.name ? output.name : 'null'}</td>
                      <td style={{ width: '220px' }}>{output.email}</td>
                      <td style={{ width: '160px' }}>{output.phone}</td>
                      <td style={{ width: '110px' }}>{output.userType === 'A' ? 'Admin' : output.userType === 'D' ? 'Donor' : output.userType === 'O' ? 'Org User' : 'User'}</td>
                      <td style={{ width: '110px' }}>{output.isActive === 1 ? 'Active' : 'Inactive'}</td>
                      <td style={{ width: '20px' }}>
                        <EditTwoTone
                          displayName='edit'
                          twoToneColor='blue'
                          style={{ fontSize: '20px' }}
                          onClick={() => {
                            editUser(output);
                          }}
                        />
                        {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                         {t('Edit')}
                       </button> */}
                      </td>
                    </tr>
                  ))
                : ' '}
            </tbody>
          </table>
          {renderList&&renderList.length == 0?<NoRecordFound/>:" "}
        </div>
      </div>
      <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={current} pageSize={50} total={pagesCount} />
    </div>
    //     </div>
    //   </div>
    // </div>
  );
}

export default Users;
